import { useRef } from 'react';
import { PlusIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { getImageAcceptAttribute } from '@/utils/image-validation';

interface AttachmentButtonProps {
    onUpload: (file: File) => void | Promise<void>;
    disabled?: boolean;
}

export function AttachmentButton({
    onUpload,
    disabled,
}: AttachmentButtonProps) {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        void onUpload(file);

        e.target.value = '';
    };

    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                accept={getImageAcceptAttribute()}
                onChange={handleFileSelect}
                className="hidden"
            />
            <Button
                variant="ghost"
                onClick={() => fileInputRef.current?.click()}
                disabled={disabled}
                leadingIcon={<PlusIcon className="size-4" />}
                aria-label={t('ariaLabels.addAttachment')}
            />
        </>
    );
}
